module.exports = __webpack_public_path__ + "assets/b5e9b2c515f3b61bcdb179c50addd09b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/buttons/close.mp3
 ** module id = 240
 ** module chunks = 0
 **/